// extracted by mini-css-extract-plugin
export default {"container":"dm_container__FRPyd","sidebar":"dm_sidebar__3X3P5","product":"dm_product__enT5L"};